import {
  Backdrop,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import Form from "../components/forms/Form";
import NavBar from "../components/NavBar";
import * as Yup from "yup";
import CustomDatePicker from "../components/forms/CustomDatePicker";
import SubmitButton from "../components/forms/SubmitButton";
import { useTheme } from "@emotion/react";
import { Box } from "@mui/system";
import ht from "../images/hotel.png";
import { getAuth } from "firebase/auth";
import ItemHolder from "../components/ItemHolder";
import {
  Kitchen,
  LocalTaxi,
  Pool,
  SportsGymnastics,
  Wifi,
} from "@mui/icons-material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../config/firebase";
import { toast } from "react-toastify";

const validationSchema = Yup.object().shape({
  startDate: Yup.date().required().label("Start Date"),
  endDate: Yup.date().required().label("End Date"),
});

const HomeScreen = () => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  const { palette } = useTheme();

  const user = getAuth.currentUser;

  const navigate = useNavigate();

  const roomsRef = collection(db, "rooms");

  console.log(user)

  React.useEffect(() => {
    if ( user && !user.uid ) {
      navigate("/", { replace: true });
    } else {
      async function fetchData() {
        setLoading(true);
        try {
          const data = await getDocs(roomsRef);
          setData(
            data.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }))
          );
        } catch (error) {
          setError(error.message);
        }
        setLoading(false);
      }
      fetchData();
    }
  }, [ navigate]);

  const handleSubmit = async ({ startDate, endDate }) => {
    //find rservations where startDate is between startDate and endDate
    const dc = collection(db, "reservations");
    const reservation = await getDocs(dc);
    const reservations = reservation.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    const filteredReservations = reservations.filter(
      (reservation) =>
        moment(reservation.startDate).isBetween(startDate, endDate) ||
        moment(reservation.endDate).isBetween(startDate, endDate)
    );
    if (filteredReservations.length > 0) {
      //get all rooms booked in between startDate and endDate
      const rooms = filteredReservations.map((reservation) => reservation.room);
      console.log(rooms, "rooms");
      //get all rooms that are not booked in between startDate and endDate

      const availableRooms = data.filter(
        (room) => rooms.map((room) => room.id).indexOf(room.id) === -1
      );
      console.log(availableRooms, "availableRooms");

      //if there are no rooms available, show error
      if (availableRooms.length === 0) {
        toast.error("Rooms are already booked for selected dates");
      }
      //if there are rooms available, show them
      else {
        //set these rooms as the data
        setData(availableRooms);
      }
    }

    //
  };

  return (
    <>
      <NavBar />
      {/* strip black section */}
      <Box
        sx={{
          p: {
            md: 3,
            xs: 3,
          },
          backgroundImage: `url(${ht})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "90vh",
          width: "100%",
        }}
      >
        <Container
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
          maxWidth="xl"
        >
          <Grid
            style={{}}
            sx={{
              bgcolor: palette.background.paper,
              p: {
                md: 1,
                xs: 1,
              },
              mt: 0.3,
            }}
            container
            spacing={3}
          >
            {loading && (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={true}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            )}

            <Form
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              initialValues={{
                startDate: "",
                endDate: "",
              }}
            >
              <Grid item xs={3}>
                <CustomDatePicker label={"startDate"} />
              </Grid>
              <Grid item xs={4}>
                <CustomDatePicker label={"endDate"} />
              </Grid>
              <Grid item xs={4}>
                <SubmitButton title={"Submit"} />
              </Grid>
            </Form>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}></Grid>
          </Grid>
          <Box>
            <Typography
              sx={{
                fontWeight: "bold",
                fontFamily: "heading",
                textAlign: "center",
                color: palette.background.paper,
                mt: 10,
              }}
              variant="h2"
              component="h2"
            >
              Welcome to the Hotel Booking System
            </Typography>
            <Typography
              sx={{
                color: palette.background.paper,
                textAlign: "center",
              }}
              variant="h5"
            >
              Good people. Good thinking. Good things.
            </Typography>
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 10,
                right: 10,
                mt: 10,
                mb: 10,
                textAlign: "center",
                color: palette.background.paper,
                backgroundColor: palette.primary.main,
                p: 4,
                borderRadius: 1,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={2.2}>
                  <ItemHolder
                    title="Kitchen"
                    icon={<Kitchen fontSize="large" />}
                  />
                </Grid>
                <Grid item xs={2.2}>
                  <ItemHolder title="Pool" icon={<Pool fontSize="large" />} />
                </Grid>
                <Grid item xs={2.2}>
                  <ItemHolder title={"Wifi"} icon={<Wifi fontSize="large" />} />
                </Grid>
                <Grid item xs={2.2}>
                  <ItemHolder
                    title={"Gym"}
                    icon={<SportsGymnastics fontSize="large" />}
                  />
                </Grid>
                <Grid item xs={2.2}>
                  <ItemHolder
                    title={"Taxi"}
                    icon={<LocalTaxi fontSize="large" />}
                  />
                </Grid>
              </Grid>
            </Box>
            {/* body */}
          </Box>
        </Container>
      </Box>
      <Box>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontFamily: "heading",
                  textAlign: "center",
                  color: palette.primary.main,
                  mt: 5,
                }}
                variant="h2"
                component="h2"
              >
                Rooms & Rates
              </Typography>
            </Grid>

            {data &&
              data.map((item) => (
                <Grid item xs={12} md={4}>
                  <Card>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="140"
                        image={item.image}
                        alt="room"
                      />

                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          Room Name: {item.name}
                        </Typography>
                        <Typography
                          variant="h6"
                          component={"div"}
                          color="text.secondary"
                        >
                          Price: Ksh {item.price}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Features:{" "}
                          {
                            //add comma after every space in the string
                            item.features.split(" ").join(", ")
                          }
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button
                        onClick={() =>
                          navigate(`/reservation/${item.id}`, {
                            state: { room: item },
                          })
                        }
                        size="medium"
                        variant="contained"
                        color="primary"
                      >
                        Book now
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </Container>
      </Box>
      <Box>
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                mt: 5,
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontFamily: "heading",
                  textAlign: "center",
                  color: palette.primary.main,
                  mt: 5,
                }}
                variant="h2"
                component="h2"
              >
                We are here to help
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* footer */}
      <Box
        sx={{
          backgroundColor: "#000000",
          color: "#ffffff",
          textAlign: "center",
          padding: "4rem",
          mt: 5,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography
                component="p"
                variant="p"
                sx={{
                  textAlign: "center",
                }}
              >
                &copy; Hotel Booking System {moment().format("YYYY")} All rights
                reserved.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default HomeScreen;
